export var Issuer;
(function (Issuer) {
  Issuer["JWT"] = "JWT";
})(Issuer || (Issuer = {}));

export const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{5,}$/;
